import React from 'react';

interface KpiPagerProps {
    page: number;
    totalPages: number;
    disabled?: boolean;
    onChange: (page: number) => void;
}

// Page numbers around the current page, with 1 and the last page always pinned.
const buildPageList = (current: number, total: number): (number | 'dots')[] => {
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages: (number | 'dots')[] = [1];
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    if (start > 2) pages.push('dots');
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push('dots');
    pages.push(total);

    return pages;
};

const KpiPager: React.FC<KpiPagerProps> = ({ page, totalPages, disabled = false, onChange }) => (
    <div className="kpi-pager">
        <button
            type="button"
            className="kpi-page-btn"
            disabled={page <= 1 || disabled}
            onClick={() => onChange(Math.max(1, page - 1))}
        >
            Previous
        </button>
        {buildPageList(page, totalPages).map((item, index) => (
            item === 'dots' ? (
                <span className="kpi-page-dots" key={`dots-${index}`}>...</span>
            ) : (
                <button
                    type="button"
                    key={item}
                    className={`kpi-page-btn ${item === page ? 'active' : ''}`}
                    disabled={disabled}
                    onClick={() => onChange(item)}
                >
                    {item}
                </button>
            )
        ))}
        <button
            type="button"
            className="kpi-page-btn"
            disabled={page >= totalPages || disabled}
            onClick={() => onChange(Math.min(totalPages, page + 1))}
        >
            Next
        </button>
    </div>
);

export default KpiPager;
